import * as React from "react";
import Box from "@mui/material/Box";
import { Icon, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";

export const ModalImg = ({ img, openImg, setOpenImg }) => {
  const handleClose = () => setOpenImg(false);

  return (
       <Modal
        open={openImg}
        onClose={handleClose}
      >
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.62)",
          }}
        >
          <Box sx={{ position: "absolute", right: 8, top: 8, zIndex: 2 }}>
            <IconButton
              aria-label="close"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
              }}
              size="large"
              sx={{ color: "white" }}
            >
              <Icon
                className={"icon-vidFleet-play-replay"}
                style={{ fontSize: 50, color: "white" }}
              >
                close
              </Icon>
            </IconButton>
          </Box>

          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: { xs: 1, sm: 2, md: 3 },
              py: { xs: 6, sm: 7, md: 8 }, 
            }}
          >
            <Box
              component="img"
              src={img}
              alt="Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                width: "auto",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Modal>
  );
};
